const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.detail || 'Admin request failed');
  }
  return payload;
};

export const fetchAdminUsers = (query = '') => {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  return request(`/users${params.toString() ? `?${params.toString()}` : ''}`);
};

export const inviteAdminUser = (payload) => request('/users/invite', {
  method: 'POST',
  body: JSON.stringify(payload)
});

export const fetchLearnerSignals = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value);
  });
  return request(`/learner-signals${query.toString() ? `?${query.toString()}` : ''}`);
};

export const fetchFeedbackMessages = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) query.set(key, value);
  });
  return request(`/feedback/messages${query.toString() ? `?${query.toString()}` : ''}`);
};

export const draftFeedback = (payload) => request('/feedback/draft', {
  method: 'POST',
  body: JSON.stringify(payload)
});

export const sendFeedback = (payload) => request('/feedback/send', {
  method: 'POST',
  body: JSON.stringify(payload)
});

export const updateAdminUser = (userId, updates) => request(`/users/${userId}`, {
  method: 'PUT',
  body: JSON.stringify(updates)
});

export const deleteAdminUser = (userId) => request(`/users/${userId}`, {
  method: 'DELETE'
});
